<template>
  <md-toolbar
    id="toolbar"
    md-elevation="0"
    class="md-transparent md-absolute"
    :class="extraNavClasses"
    :color-on-scroll="colorOnScroll"
  >
    <div class="md-toolbar-row md-collapse-lateral">
      <div v-if="Toolimg" class="md-toolbar-section-start">
        <h3 class="md-title">
          <img
            style="width:135px;;"
            src="@/assets/img/yourplace/YP-Gold@4x.png"
          />
        </h3>
      </div>
      <div v-else class="md-toolbar-section-start">
        <h3 class="md-title">
          <img
            style="width:135px"
            src="@/assets/img/yourplace/YP-Gold@4x.png"
          />
        </h3>
      </div>
      <div class="md-toolbar-section-end">
        <md-button
          class="md-just-icon md-simple md-toolbar-toggle"
          :class="{ toggled: toggledClass }"
          @click="toggleNavbarMobile()"
        >
          <span class="icon-bar"></span>
          <span class="icon-bar"></span>
          <span class="icon-bar"></span>
        </md-button>

        <div class="md-collapse">
          <div class="md-collapse-wrapper">
            <mobile-menu nav-mobile-section-start="false">
              <!-- Here you can add your items from the section-start of your toolbar -->
            </mobile-menu>
            <md-list style="margin-right: 100px;">
              <li class="md-list-item" v-if="!showDownload">
                <a
                  href="javascript:void(0)"
                  class="md-list-item-router md-list-item-container md-button-clean dropdown"
                >
                  <div class="md-list-item-content">
                    <drop-down direction="down">
                      <md-button
                        slot="title"
                        class="md-button md-button-link md-white md-simple dropdown-toggle"
                        data-toggle="dropdown"
                      >
                        <i class="material-icons">apps</i>
                        <p>Components</p>
                      </md-button>
                      <ul class="dropdown-menu dropdown-with-icons">
                        <li>
                          <a href="#/">
                            <i class="material-icons">layers</i>
                            <p>All Components</p>
                          </a>
                        </li>
                        <li>
                          <a
                            href="https://demos.creative-tim.com/vue-material-kit/documentation/"
                          >
                            <i class="material-icons">content_paste</i>
                            <p>Documentation</p>
                          </a>
                        </li>
                      </ul>
                    </drop-down>
                  </div>
                </a>
              </li>

              <!-- <md-list-item 
              >
                <router-link  :style="color" to="/"><span @click="changecolor('index')">Home</span></router-link>
                
              </md-list-item>

               <md-list-item
                
              >
                <router-link :style="color" to="/locations"><span @click="changecolor('locations')">Locations</span></router-link>
                
              </md-list-item>


           

               <md-list-item
                
              >
                <router-link  :style="color" to="/aboutus"><span @click="changecolor('aboutus')">About Us</span></router-link>
                
              </md-list-item>

               <md-list-item
                
              >
                <router-link  :style="color" to="/contactus"><span @click="changecolor('contactus')">Contact Us</span></router-link>
                
              </md-list-item> -->
              <!-- <md-list-item>
            
               <select class="btn btn-default dropdown-toggle" style="color:white;" searchable="Search here..">
        <option value="english" style="background:transparent;"  selected><img src="" />English</option>
        <option value="arabic" style="background:transparent;">Arabic</option>
        
        
      </select>
                    
            </md-list-item> -->
              <md-list-item>
                <router-link to="/contactus">
                  <md-button
                    style="display: flex;flex-direction: row;justify-content: center;align-items: center;padding: 6px 16pxposition: absolute;width: 158px;height: 40px;background: #C1A360!important;border-radius: 4px;"
                    class=""
                    >Request a call
                  </md-button>
                </router-link>
              </md-list-item>
            </md-list>
          </div>
        </div>
      </div>
    </div>
  </md-toolbar>
</template>

<script>
let resizeTimeout;
function resizeThrottler(actualResizeHandler) {
  // ignore resize events as long as an actualResizeHandler execution is in the queue
  if (!resizeTimeout) {
    resizeTimeout = setTimeout(() => {
      resizeTimeout = null;
      actualResizeHandler();

      // The actualResizeHandler will execute at a rate of 15fps
    }, 66);
  }
}

import MobileMenu from "@/layout/MobileMenu";
export default {
  components: {
    MobileMenu
  },
  props: {
    type: {
      type: String,
      default: "white",
      validator(value) {
        return [
          "white",
          "default",
          "primary",
          "danger",
          "success",
          "warning",
          "info"
        ].includes(value);
      }
    },
    colorOnScroll: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      name: "",
      color: "color:white !important;",
      Toolimg: true,
      extraNavClasses: "",
      toggledClass: false
    };
  },
  computed: {
    showDownload() {
      const excludedRoutes = ["login", "landing", "profile"];
      return excludedRoutes.every(r => r !== this.$route.name);
    }
  },
  methods: {
    bodyClick() {
      let bodyClick = document.getElementById("bodyClick");

      if (bodyClick === null) {
        let body = document.querySelector("body");
        let elem = document.createElement("div");
        elem.setAttribute("id", "bodyClick");
        body.appendChild(elem);

        let bodyClick = document.getElementById("bodyClick");
        bodyClick.addEventListener("click", this.toggleNavbarMobile);
      } else {
        bodyClick.remove();
      }
    },
    toggleNavbarMobile() {
      this.NavbarStore.showNavbar = !this.NavbarStore.showNavbar;
      this.toggledClass = !this.toggledClass;
      this.bodyClick();
    },
    handleScroll() {
      let scrollValue =
        document.body.scrollTop || document.documentElement.scrollTop;
      let navbarColor = document.getElementById("toolbar");
      this.currentScrollValue = scrollValue;
      this.name = this.$route.name;

      if (this.colorOnScroll > 0 && scrollValue > this.colorOnScroll) {
        this.Toolimg = false;
        this.extraNavClasses = `md-${this.type}`;
        navbarColor.classList.remove("md-transparent");
        this.color = "color:black !important;";
      } else {
        if (this.extraNavClasses) {
          if (this.name == "index") {
            this.extraNavClasses = "";

            navbarColor.classList.add("md-transparent");
            this.color = "color:white !important;";
            this.Toolimg = true;
          }
          if (this.name == "Contactus") {
            this.extraNavClasses = "";
            this.Toolimg = false;
            this.color = "color:black !important;";
          }
          if (this.name == "locations") {
            this.extraNavClasses = "";
            this.Toolimg = false;
            this.color = "color:black !important;";
          }
          if (this.name == "aboutus") {
            this.extraNavClasses = "";
            this.Toolimg = false;
            this.color = "color:black !important;";
          }
        }
      }
    },
    changecolor(type) {
      if (type == "index") {
        this.color = "color:white !important;";
        this.Toolimg = true;
      }
      if (type == "Contactus") {
        this.Toolimg = false;
        this.color = "color:black !important;";
      }
      if (type == "locations") {
        this.Toolimg = false;
        this.color = "color:black !important;";
      }
      if (type == "aboutus") {
        this.Toolimg = false;
        this.color = "color:black !important;";
      }
    },
    scrollListener() {
      resizeThrottler(this.handleScroll);
    },
    scrollToElement() {
      let element_id = document.getElementById("downloadSection");
      if (element_id) {
        element_id.scrollIntoView({ block: "end", behavior: "smooth" });
      }
    }
  },
  mounted() {
    document.addEventListener("scroll", this.scrollListener);
    this.changecolor();
  },
  beforeDestroy() {
    document.removeEventListener("scroll", this.scrollListener);
  }
};
</script>
